
<agpr-take-over-panel
    [id]="id"
    header="Common.brandIdentity.manageDialog.heading"
    [width]="100"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="onVisibleChange($event)"
>
    <div
        class='agpr-manageBrandIdentitiesDialog-content'
        [agprLoading]="loading"
        [style]="{ 'margin-top': brandList?.length ? '17px' : '0' }"
    >
        <div
            class="agpr-manageBrandIdentitiesDialog-lhp"
            [class]="{
                'agpr-manageBrandIdentitiesDialog-lhp--disabled': !brandList?.length
            }"
        >
            @if (brandList?.length) {
                <div class="agpr-manageBrandIdentitiesDialog-toolbar">
                    <span>
                        {{ 'Common.brandIdentity.manageDialog.message' | localize }}
                    </span>
                    <div class="agpr-manageBrandIdentitiesDialog-toolbar-actions">
                        <agpr-text-input
                            [id]="id + '_searchInput'"
                            class="agpr-manageBrandIdentitiesDialog-toolbar-searchInput"
                            icon="fa-regular fa-duotone fa-magnifying-glass"
                            ariaLabel="Common.brandIdentity.manageDialog.search.label"
                            [(ngModel)]="searchText"
                            [maxLength]="256"
                            [bottomMargin]="false"
                            (input)="filterBrandIdentities()"
                        ></agpr-text-input>
                        <agpr-button
                            [id]="id + '_add'"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-square-plus"
                            tooltip="Common.brandIdentity.manageDialog.button.add.tooltip"
                            [tooltipPosition]="'top'"
                            (click)="addBrand()"
                        ></agpr-button>
                    </div>
                </div>

                <agpr-scroll-panel
                    #brandListScrollPanel
                    class="agpr-manageBrandIdentitiesDialog-scrollpanel"
                >
                    <ul
                        id="brandList'"
                        class="agpr-manageBrandIdentitiesDialog-brandList"
                        agprListKeyboardNavigation
                        [list]="brandList"
                        cdkDropList
                        [cdkDropListData]="brandList"
                        [cdkDropListConnectedTo]="['competitorList']"
                        (cdkDropListDropped)="drop($event)"
                    >
                        @for (brand of filteredBrandList; track brand.id; let i = $index;) {
                            <li
                                #brandItem
                                class="agpr-manageBrandIdentitiesDialog-brandListItem agpr-contextMenu-parent"
                                [class]="{
                                    'agpr-manageBrandIdentitiesDialog-brandListItem--selected': selectedBrand?.id === brand.id
                                }"
                                [attr.data-id]="brand.id"
                                cdkDragPreviewClass="agpr-manageBrandIdentitiesDialog-brandListItem--preview"
                                cdkDrag
                                (cdkDragMoved)="onDragMoved($event)"
                            >
                                <div
                                    class="agpr-manageBrandIdentitiesDialog-brandListItem-activeBar"
                                    [style.visibility]="selectedBrand?.id === brand.id ? 'visible' : 'hidden'"
                                ></div>
                                <agpr-brand-identity-card
                                    [id]="id + '_brandCard_' + i"
                                    class="agpr-manageBrandIdentitiesDialog-brandCard"
                                    [brand]="brand"
                                    [showBorder]="false"
                                    (click)="selectBrand(brand)"
                                ></agpr-brand-identity-card>
                                <div class="agpr-contextMenu top left">
                                    @if (!$first) {
                                        <agpr-button
                                            [id]="id + '_moveUp_' + i "
                                            [style]="buttonTypes.contextMenu"
                                            icon="fa-regular fa-arrow-up"
                                            tooltip="Common.brandIdentity.manageDialog.button.moveUp"
                                            [tooltipPosition]="'top'"
                                            (click)="moveUp(i)"
                                        ></agpr-button>
                                    }
                                    @if (!$last) {
                                        <agpr-button
                                            [id]="id + '_moveDown_' + i "
                                            [style]="buttonTypes.contextMenu"
                                            icon="fa-regular fa-arrow-down"
                                            tooltip="Common.brandIdentity.manageDialog.button.moveDown"
                                            [tooltipPosition]="'top'"
                                            (click)="moveDown(i)"
                                        ></agpr-button>
                                    }
                                </div>
                                @if (brand?.primary) {
                                    <agpr-button
                                        [id]="id + '_primary_' + i"
                                        class="agpr-manageBrandIdentitiesDialog-primaryIcon"
                                        [style]="buttonTypes.icon"
                                        icon="fa-solid fa-star"
                                        tooltip="Common.brandIdentity.manageDialog.primary"
                                        [tooltipPosition]="'top'"
                                        (click)="togglePrimary(brand)"
                                        [disabled]="brandList.length > 1"
                                    ></agpr-button>
                                    @if (brandList.length === 1) {
                                        <div class="agpr-contextMenu top right">
                                            <agpr-button
                                                [id]="id + '_delete_' + i"
                                                [style]="buttonTypes.contextMenu"
                                                icon="fa-regular fa-duotone fa-trash-can"
                                                tooltip="Common.brandIdentity.manageDialog.button.delete"
                                                [tooltipPosition]="'top'"
                                                (click)="delete(brand)"
                                            ></agpr-button>
                                        </div>
                                    }
                                } @else {
                                    <div class="agpr-contextMenu top right">
                                        <agpr-button
                                            [id]="id + '_setPrimary_' + i"
                                            [style]="buttonTypes.contextMenu"
                                            icon="fa-regular fa-duotone fa-star"
                                            tooltip="Common.brandIdentity.manageDialog.button.setPrimary"
                                            [tooltipPosition]="'top'"
                                            (click)="togglePrimary(brand)"
                                        ></agpr-button>
                                        <agpr-button
                                            [id]="id + '_delete_' + i"
                                            [style]="buttonTypes.contextMenu"
                                            icon="fa-regular fa-duotone fa-trash-can"
                                            tooltip="Common.brandIdentity.manageDialog.button.delete"
                                            [tooltipPosition]="'top'"
                                            (click)="delete(brand)"
                                        ></agpr-button>
                                    </div>
                                }
                                @let competitorTooltips = competitorRecord[brand.id] + competitorOfRecord[brand.id];
                                @if (competitorTooltips) {
                                    <span
                                        role="img"
                                        class="agpr-manageBrandIdentitiesDialog-competitorIcon fa-duotone fa-regular fa-diagram-nested"
                                        [agprTooltip]="competitorTooltips"
                                        tooltipStyleClass="agpr-manageBrandIdentitiesDialog-competitorTooltip"
                                        [escape]="false"
                                        [autoHide]="false"
                                        [tooltipClickListener]="competitorTooltipHandler"
                                    ></span>
                                }
                            <ng-template cdkDragPlaceholder>
                                <div class="agpr-manageBrandIdentitiesDialog-brandListItem--placeholder"></div>
                            </ng-template>
                        </li>
                        }
                        @if (!filteredBrandList.length) {
                            <li>
                                <agpr-message
                                    [id]="id + '_noBrandsMessage'"
                                    class="agpr-manageBrandIdentitiesDialog-noBrandsMessage"
                                    [severity]="messageSeverity.noContent"
                                    [bottomMargin]="false"
                                >
                                    {{ 'Common.brandIdentity.manageDialog.noBrandsMessage' | localize}}
                                </agpr-message>
                            </li>
                        }
                    </ul>
                </agpr-scroll-panel>
            }
        </div>
        <div class="agpr-manageBrandIdentitiesDialog-rhp">
            <agpr-scroll-panel class="agpr-manageBrandIdentitiesDialog-scrollpanel">
                <div class="agpr-manageBrandIdentitiesDialog-rhp-content">
                    @if(!brandList?.length) {
                        <!-- Landing page when no brands exist -->
                        <div class="agpr-manageBrandIdentitiesDialog-landingMsg">
                            <span
                                role="img"
                                class="agpr-manageBrandIdentitiesDialog-landingMsg-icon fa-kit-duotone fa-agpr-brand-identity"
                            ></span>
                            <span>{{ 'Common.brandIdentity.manageDialog.message' | localize }}</span>
                        </div>
                        <agpr-brand-identity-card
                            [id]="id + '_createBrandCard'"
                            [brand]="selectedBrand"
                        ></agpr-brand-identity-card>
                    } @else {
                        @if (selectedBrand?.id || selectedBrand?.id === 0) {
                            <agpr-brand-information
                                #brandInformation
                                [id]="id + '_brandInformation'"
                                (selectBrand)="onSelectBrand($event)"
                            ></agpr-brand-information>
                        } @else if (selectedBrand) {
                            <agpr-brand-identity-card
                                [id]="id + '_createBrandCard'"
                                [brand]="selectedBrand"
                            ></agpr-brand-identity-card>
                        }
                    }
                </div>
            </agpr-scroll-panel>
        </div>
    </div>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_done'"
            [style]="buttonTypes.primary"
            label="Common.brandIdentity.manageDialog.button.done"
            (click)="close()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>

